import React, {Component} from 'react';
import {object} from 'prop-types';

import _ from 'lodash';

import Paper from '@material-ui/core/Paper';

import AreaItemPanelInsert from './AreaItemPanelInsert';
import PanelHeader from '../../components/PanelHeader';
import CampusPanelInsert from './CampusPanelInsert';
import ClientPanelInsert from './ClientPanelInsert';
import CompanyPanelInsert from './CompanyPanelInsert';
import EquipmentItemPanelInsert from './EquipmentItemPanelInsert';
import SitePanelInsert from './SitePanelInsert';
import SystemItemPanelInsert from './SystemItemPanelInsert';

import classes from './InformationPanel.module.css';

class InformationPanel extends Component {
    renderPanel = node => {
        switch (node.type) {
            case 'areaItem':
                return (
                    <AreaItemPanelInsert
                        node={node}
                    />
                );
            case 'campus':
                return (
                    <CampusPanelInsert
                        node={node}
                    />
                );
            case 'client':
                return (
                    <ClientPanelInsert
                        node={node}
                    />
                );
            case 'company':
                return (
                    <CompanyPanelInsert
                        node={node}
                    />
                );
            case 'equipmentItem':
                return (
                    <EquipmentItemPanelInsert
                        node={node}
                    />
                );
            case 'site':
                return (
                    <SitePanelInsert
                        node={node}
                    />
                );
            case 'systemItem':
                return (
                    <SystemItemPanelInsert
                        node={node}
                    />
                );
            default:
                return (
                    <p className={classes.emptyActions}>No additional information available.</p>
                );
        }
    }

    prepareTitle = ({type}) => {
        if (type && _.isString(type)) {
            if (type.includes('Item')) {
                switch (type) {
                    case 'equipmentItem':
                        return 'Equipment Information';
                    case 'areaItem':
                        return 'Area Information';
                    case 'systemItem':
                        return 'System Information';
                    default:
                        break;
                }
            }

            return `${type} Information`;
        }

        return 'Information Panel';
    }

    prepareImage = ({type}) => {
        switch (type) {
            case 'campus':
                return '/assets/images/campusTreeIcon.svg';
            case 'company':
                return '/assets/images/companyTreeIcon.svg';
            case 'client':
                return '/assets/images/clientTreeIcon.svg';
            case 'site':
                return '/assets/images/siteTreeIcon.svg';
            case 'area':
            case 'areaItem':
                return '/assets/images/areaTreeIcon.svg';
            case 'equipment':
            case 'equipmentItem':
                return '/assets/images/equipmentTreeIcon.svg';
            case 'system':
            case 'systemItem':
                return '/assets/images/systemTreeIcon.svg';
            default:
                return '/assets/images/SettingsFlat.svg';
        }
    }

    render() {
        const {node} = this.props;

        if (!node) return null;

        const title = this.prepareTitle(node);
        const image = this.prepareImage(node);

        return (
            <Paper className={classes.InformationPanel}>
                <div className={classes.header}>
                    <PanelHeader
                        title={title}
                        url={image}
                    />
                </div>
                <div>
                    {this.renderPanel(node)}
                </div>
            </Paper>
        );
    }
}

InformationPanel.defaultProps = {
    node: {}
};

InformationPanel.propTypes = {
    node: object
};

export default InformationPanel;
